import { Placement } from '@react-types/overlays'

export const positionConstants: Record<string, Placement> = {
   bottom: 'bottom',
   bottomLeft: 'bottom left',
   bottomRight: 'bottom right',
   left: 'left',
   leftBottom: 'left bottom',
   leftTop: 'left top',
   right: 'right',
   top: 'top',
   topLeft: 'top left',
   topRight: 'top right',
   bottomStart: 'bottom start',
   bottomEnd: 'bottom end'
}
